// @flow
import React from 'react'
import { Redirect } from 'react-router-dom'

const DevComponent = () => {
	return <Redirect to={'/procure/store'} />
}

export default DevComponent
